import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const GetAPIIngestionData = async (params: any) => {
  try {    
    const response = await postCall(urlConfig.GetApiIngestionDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error in Get API Ingestion Data", error);
    throw error;
  }
};
